<template>
	<div class="container">
		<div class="base-div">
			<div class="content">
				<div v-if="dataList.length>0" class="message-wrap">
					<div class="message" v-for="item in dataList" :key="item.id">
						<messageItem :item="item" :isShowHeadPic="true" @toReply="toReply"/>
					</div>
				</div>
				<div v-else class="message-wrap">
					<contentno content="暂时没有留言"/>
				</div>
				<div class="page-size">
					<el-pagination
					background
					layout="prev, pager, next"
					:page-size= this.pageSize
					:total=this.total
					@current-change="handleCurrentChange"
					:current-page = "pageNum"
					hide-on-single-page
					>
					</el-pagination>
				</div>
			</div>
			<div class="aside">
				<messageHot/>
			</div>
		</div>
		<el-dialog title="回复留言" width="50%" :visible.sync="replyDailog">
			<div class="dialog-wrap">
				<div class="reply-title">
					RE：{{title}}
				</div>
				<div style="border: 1px solid #EBEBEB;">
					<Toolbar
						style="border-bottom: 1px solid #EBEBEB"
						:editor="editor"
						:defaultConfig="toolbarConfig"
						:mode="mode"
					/>
					<Editor
						style="height: 200px; overflow-y: hidden;"
						v-model="html"
						:defaultConfig="editorConfig"
						:mode="mode"
						@onCreated="onCreated"
					/>
				</div>
				<div class="create-btn" @click="createMessage">回复留言</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import messageHot from '@/components/Message/messageHot.vue'
	import messageItem from '@/components/Message/messageItem.vue'
	import contentno from '@/components/contentno/index.vue'
	import qs from 'qs'
	import { post, config, ajaxParam } from '@/units/request.js'
	import '@wangeditor/editor/dist/css/style.css'
	import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
	export default {
		name: 'MessageNew',
		data(){
			return {
				activityId: '',
				pageNum: 1,
				pageSize: 8,
				sortType: 2, //排序  1：最新发表  2：最新回复  3：最多回复
				dataList: [],
				total: 0,
				replyDailog: false,
				replyId: '',
				editor: null,
				toolbarConfig: {
					excludeKeys: [
						'insertVideo'
					]
				},
				editorConfig: {
					placeholder: '请输入内容...' ,
					MENU_CONF: {
						uploadImage: {
							server: config.baseUrl + "v1/upload/editorUpload",
							fieldName: "file"
						}
					}
				},
				html: '',
				mode: 'simple', // or 'simple'
				title: ''
			}
		},
		components: {
			contentno,
			messageHot,
			messageItem,
			Editor, Toolbar
		},
		methods: {
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			},
			toReply(e){
				if(!this.userId){
					this.$router.push('/login')
					return
				}
				this.replyDailog = true
				this.replyId = e.id
				this.title = e.title
				this.html = ''
			},
			//发表留言
			async createMessage(){
				if(this.html.length<=0||this.html=='<p><br></p>'){
					this.$message.error('请输入留言，不能为空！')
					return
				}
				let url = 'v1/suggest/create'
				let param = {
					activityId: this.activityId,
					content: this.html,
					addUserId: this.userId,
					replyId: this.replyId,
					title: this.title
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if(res.data.code==200) {
					this.$message.success('回复成功！')
					this.replyDailog = false
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//留言列表
			async getDataList(){
				let url = 'v1/suggest/list'
				let param = {
					activityId: this.activityId,
					sortType: this.sortType,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if(res.data.code==200) {
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//分页
			handleCurrentChange(e){
				this.dataList = []
				this.pageNum = e
				this.getDataList()
			},
		},
		created(){
			this.userId = localStorage.getItem('userId')
			this.activityId = localStorage.getItem('activityId')
			this.getDataList()
		},
		beforeDestroy() {
			const editor = this.editor
			if (editor == null) return
			editor.destroy() // 组件销毁时，及时销毁编辑器
		}
	}
</script>

<style scoped lang="less">
	@import './message.less';
</style>
